// extracted by mini-css-extract-plugin
export var first = "styles-module--first--8232d";
export var line = "styles-module--line--84961";
export var opened = "styles-module--opened--c419f";
export var second = "styles-module--second--8d80b";
export var wrapper = "styles-module--wrapper--1a780";